// extracted by mini-css-extract-plugin
export default {"dateSwitch":"DateSwitch_dateSwitch__OSOHB","datePickerArea":"DateSwitch_datePickerArea__uUSlf","switchBtn":"DateSwitch_switchBtn__HW5u3","label":"DateSwitch_label__i+xhu"};